const setSlideShow = () => {
  const sliders = document.querySelectorAll(".component-hub-slideshow");
  Array.from(sliders).forEach((slider) => {
    const id = slider.getAttribute("id");
    const isCollectionSlideshow = slider.classList.contains("component-hub-collection-slideshow");
    new Swiper(`#${id}`, {
      direction: "horizontal",
      slidesPerView: isCollectionSlideshow ? 2.2 : 1.5,
      spaceBetween: isCollectionSlideshow ? 6 : 10,
      simulateTouch: true,
      allowTouchMove: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      },
      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
};

setSlideShow();
